export class TraceContext {

    /**
     * See https://www.w3.org/TR/trace-context/#trace-id
     * @type {string}
     * @memberof TraceContext
     */
    traceId: string;

    /**
     * See https://www.w3.org/TR/trace-context/#parent-id
     *
     * @type {string}
     * @memberof TraceContext
     */
    spanId: string;

    /**
     * See https://www.w3.org/TR/trace-context/#parent-id
     *
     * @type {string}
     * @memberof TraceContext
     */
    parentId: string;


    /**
     * See https://www.w3.org/TR/trace-context/#trace-flags
     * @type {string}
     * @memberof TraceContext
     */
    flags: string = '00';

    constructor() {
        this.start();
    }


    /** 
     * Start new trace context
     * This will genereate new TraceId and SpanId
     * @memberof TraceContext
     */
    start(): void {
        this.traceId = this.generateRandomHex(32);
        this.newSpan();
    }

    /**
     * Start trace context from traceparent value
     * This will use same TraceId and set correct ParentId
     * @param {string} traceparent
     * @memberof TraceContext
     */
    startFrom(traceparent: string): void {
        const [_, traceId, spanId, flags] = traceparent.split('-');

        this.traceId = traceId;
        this.parentId = spanId;
        this.flags = flags;
    }

    /**
     * Generate new SpanId value
     * @memberof TraceContext
     */
    newSpan(): void {
        this.spanId = this.generateRandomHex(16);
    }

    /**
     * Header name constant 
     * See https://www.w3.org/TR/trace-context/#header-name
     * @readonly
     * @type {string}
     * @memberof TraceContext
     */
    get traceParentHeaderName(): string {
        return 'traceparent';
    }

    /**
     * traceparent header value
     * See https://www.w3.org/TR/trace-context/#examples-of-http-traceparent-headers
     * @readonly
     * @type {string}
     * @memberof TraceContext
     */
    get traceParentHeader(): string {
        return `00-${this.traceId}-${this.spanId}-${this.flags}`
    }

    private generateRandomHex(length: number): string {
        const characters = "0123456789abcdef"
        let hex = ""

        for (let i = 0; i < length; i++) {
            hex += characters[Math.floor(Math.random() * 16)]
        }

        return hex;
    }
}